import React from 'react';
import { motion } from 'framer-motion';
export function HeroSection() {
  return <section className="pt-16 pb-12 px-4 max-w-4xl mx-auto text-center" data-id="element-62">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.6
    }} data-id="element-63">
        <h1 className="text-4xl sm:text-5xl md:text-6xl font-extrabold text-[#2D1B06] leading-tight mb-6" data-id="element-64">
          ¿Sientes que{' '}
          <span className="text-[#E8820C] italic" data-id="element-65">"solo con oler el pan"</span>{' '}
          ya subiste un kilo?
        </h1>

        <h2 className="text-xl sm:text-2xl text-[#2D1B06]/80 font-medium leading-relaxed max-w-3xl mx-auto mb-10" data-id="element-66">
          Cómo resetear tu metabolismo y desbloquear la quema de grasa en 21
          días sin pasar hambre{' '}
          <span className="underline decoration-[#E8820C] decoration-4 underline-offset-4" data-id="element-67">
            (incluso si ya lo intentaste todo).
          </span>
        </h2>

        <div className="bg-white/60 backdrop-blur-sm border border-[#E8820C]/20 p-6 rounded-2xl shadow-lg max-w-2xl mx-auto" data-id="element-68">
          <p className="text-lg text-[#2D1B06] font-semibold" data-id="element-69">
            Descubre el protocolo hormonal diseñado para hispanos que sufren de
            metabolismo lento, inflamación abdominal y fatiga crónica.
          </p>
        </div>
      </motion.div>
    </section>;
}